<div class="wrapper">
  <div  class="content" #content>
    <!-- SITES -->

    <div (click)="openOrClose()" class="no-select" id="search-value"
    [ngClass]="{ 'search-value-active': toggleSelect  }">
      <i class="fas fa-globe-europe"></i>
      <span>{{currentSite?.region?.nom}}</span>
      <i class="fas fa-chevron-right"></i>
      <i class="fas fa-map-marker-alt"></i>
      <span> {{currentSite?.nom}}</span>

    </div>

    <div class="dropdown-content" [ngClass]="{ close: !toggleSelect, open: toggleSelect  }">

      <div class="search">
        <i class="fas fa-search"></i>
        <input #inputRef type="text" placeholder="{{ 'PLACEHOLDERS.SEARCH' | translate }}" id="search-input"
          (keyup)="filterSearchSites($event)" class="w-100" />

      </div>

      <ul class="options no-select" [ngClass]="{ close: !toggleSelect, open: toggleSelect  }">
        <li role="menuitem" *ngFor="let site of listeSites_filtred; let i = index">
          <a class="dropdown-item nom-region" style="cursor: default !important" *ngIf="i == 0">{{
            site?.groupByNomRegion }}</a>
          <a class="dropdown-item" [ngClass]="{ selected: site.siteId === selectedSite?.siteId}" *ngIf="i == 0"
            (click)="definirSiteEnCours(site, $event);">{{ site?.nom }}</a>
          <ng-container *ngIf="i > 0">
            <a class="dropdown-item nom-region" style="cursor: default !important" *ngIf="
                i > 0 &&
                listeSites_filtred[i - 1].groupByNomRegion !=
                  site?.groupByNomRegion
              ">{{ site?.groupByNomRegion }}</a>
            <a class="dropdown-item" [ngClass]="{ selected: site.siteId === selectedSite?.siteId }" *ngIf="
                i > 0 &&
                listeSites_filtred[i - 1].groupByNomRegion !=
                  site?.groupByNomRegion
              " (click)="definirSiteEnCours(site, $event)">{{ site?.nom }}</a>
            <a class="dropdown-item" [ngClass]="{ selected: site.siteId === selectedSite?.siteId }" *ngIf="
                i > 0 &&
                listeSites_filtred[i - 1].groupByNomRegion ==
                  site?.groupByNomRegion
              " (click)="definirSiteEnCours(site, $event)">{{ site?.nom }}
            </a>
          </ng-container>
        </li>
      </ul>
    </div>

    <!-- SITES -->
  </div>

  <div class="select-btn no-select " (click)="toggleSelect = !toggleSelect; $event.stopPropagation()"
  [ngClass]="{ 'select-btn-active': toggleSelect  }">
    <i class="fa-solid fa-caret-down" [ngClass]="{
        'rotate-down': !toggleSelect,
        'rotate-up': toggleSelect
      }"></i>
  </div>
</div>